import { render } from "./NFTtemplate.vue?vue&type=template&id=563c913a"
import script from "./NFTtemplate.vue?vue&type=script&lang=js"
export * from "./NFTtemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__